import BasicEmotionsDeckIMG from "../../assets/DeckCards/Emotions/BasicEmotionsDeckIMG.png";
import ComplexEmotionsDeckIMG from "../../assets/DeckCards/Emotions/ComplexEmotionsDeckIMG.png";
import NegativeEmotionsDeckIMG from "../../assets/DeckCards/Emotions/NegativeEmotionsDeckIMG.png";
import PositiveEmotionsDeckIMG from "../../assets/DeckCards/Emotions/PositiveEmotionsDeckIMG.png";

export const EmotionsDeckFace = [

    {
        id: "basic_emotions",
        Title: "Basic Emotions",
        Description: "Learn foundational emotion words in Korean!",
        Difficulty: "Beginner 2",
        Image: BasicEmotionsDeckIMG,
        Link: "/BasicEmotionsDeck",
        cssId: "basic-emotions-ID"
    },

    {
        id: "negative_emotions",
        Title: "Negative Emotions",
        Description: "Expand your vocabulary with emotions that express discomfort or sadness!",
        Difficulty: "Beginner 2",
        Image: NegativeEmotionsDeckIMG,
        Link: "/NegativeEmotionsDeck",
        cssId: "negative-emotions-ID"
    },

    {
        id: "positive_emotions",
        Title: "Positive Emotions",
        Description: "Learn words that express happiness, satisfaction, and positivity!",
        Difficulty: "Beginner 2",
        Image: PositiveEmotionsDeckIMG,
        Link: "/PositiveEmotionsDeck",
        cssId: "positive-emotions-ID"
    },

    {
        id: "complex_emotions",
        Title: "Complex Emotions",
        Description: "Learn more nuanced and situational emotions!",
        Difficulty: "Beginner 2",
        Image: ComplexEmotionsDeckIMG,
        Link: "/ComplexEmotionsDeck",
        cssId: "complex-emotions-ID"
    },

];


